<template>
  <button
    class="button --bare --plain +circular"
    :class="{ 'floating-button': !isDesktop && scrollPosition >= 80 }"
    role="button"
    @click="$emit('toggle')"
  >
    <span
      class="icon-container +circular +bg-white"
      :class="[isSaved ? 'is-saved' : 'is-not-saved']"
    >
      <span class="icon" :class="[isSaved ? '+fill-blue' : 'fill-black']">
        <bookmark-icon :isSaved="isSaved"></bookmark-icon>
      </span>
      <span class="+visually-hidden">{{ isArticleSavedAssistiveText }}</span>
    </span>
  </button>
</template>

<script>
import bookmarkIcon from '../assets/svg/bookmark-icon.vue'

export default {
  name: 'bookmark-button',
  props: {
    isSaved: {
      type: Boolean,
      default: false
    }
  },

  data: function() {
    return {
      scrollPosition: null
    }
  },

  mounted() {
    window.addEventListener('scroll', this.updateScroll)
  },

  computed: {
    isDesktop: () => {
      return window.screen.width >= 768
    },

    isArticleSavedAssistiveText() {
      return !this.isSaved
        ? 'Add article to saved articles'
        : 'Remove article from saved articles'
    }
  },

  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY
    }
  },

  components: {
    bookmarkIcon
  }
}
</script>

<style>
.fill-black {
  color: #000;
  fill: #000;
}
</style>

<style lang="scss" scoped>
.icon-container {
  display: inline-block;
  line-height: 1;
  padding: 0.38888889rem;
  border: 2px solid;
}

.icon-container.is-not-saved {
  border-color: #ffce48;
}

.icon-container.is-saved {
  border-color: #cfcfd4;
}

.floating-button {
  box-shadow: 0px 5px 8px 3.5px rgba(0, 0, 0, 0.2);
  position: fixed;
  right: 14px;
  top: 14px;
  z-index: 5;
}

#csstyle .\+circular {
  border-radius: 50%;
}

#csstyle .\+visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
</style>
